import {
  createContext,
  type ReactNode,
  useContext,
  useMemo,
  useState,
} from "react"

interface DocumentHasLocalEditsContextValue {
  hasLocalEdits: boolean
  setHasLocalEdits: (hasLocalEdits: boolean) => void
}

const DocumentHasLocalEditsContext =
  createContext<DocumentHasLocalEditsContextValue>({
    hasLocalEdits: false,
    setHasLocalEdits: () => {},
  })

interface DocumentHasLocalEditsProviderProps {
  children: ReactNode
}

export function DocumentHasLocalEditsProvider(
  props: DocumentHasLocalEditsProviderProps,
) {
  const { children } = props

  const [hasLocalEdits, setHasLocalEdits] = useState(false)
  const value = useMemo(
    () => ({ hasLocalEdits, setHasLocalEdits }),
    [hasLocalEdits],
  )

  return (
    <DocumentHasLocalEditsContext.Provider value={value}>
      {children}
    </DocumentHasLocalEditsContext.Provider>
  )
}

export function useDocumentHasLocalEdits() {
  return useContext(DocumentHasLocalEditsContext)
}
